import React, { useEffect } from 'react'

import { Paper } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useConfirm } from 'material-ui-confirm'
import { DeleteOutlineOutlined as DeleteIcon, EditOutlined as EditIcon } from '@material-ui/icons'
import Tooltip from '@material-ui/core/Tooltip'

import ActionBar from 'components/ActionBar'
import ViewHeader from 'components/ViewHeader'
import Loading from 'components/Loading'
import getTableOptions from 'utils/getTableOptions'
import ResourceNotFound from 'components/ResourceNotFound'
import BasicTable from 'components/BasicTable'
import { renderCol } from 'utils/renderColumns'
import vendorSlice, { deleteVendorById, getVendors } from 'store/vendor'
import { caseInsensitiveSort } from 'utils'

const VendorListing = () => {
  const dispatch = useDispatch()
  const confirm = useConfirm()
  const history = useHistory()
  const location = useLocation()

  const { user } = useSelector((state) => state.auth)
  const { vendors, currentPage, pageSize, inProgress } = useSelector((state) => state.vendor)

  useEffect(() => {
    const unsub = getVendors(user?.conferenceId, (data) => {
      dispatch(vendorSlice.actions.setVendors(caseInsensitiveSort(data, 'name')))
    })
    return () => unsub && unsub()
  }, [dispatch, user?.conferenceId])

  const tableHead = [
    'Full Name',
    'Email',
    'Booth No',
    {
      name: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => renderCol(value),
        customHeadLabelRender: (meta) => renderCol(meta.label)
      }
    }
  ]
  const formatTableData = (vendors) =>
    vendors.map((vendor) => [
      vendor?.name,
      vendor?.email,
      vendor?.booth ?? 'N/A',
      <>
        <Tooltip title="Edit">
          <EditIcon
            color="action"
            style={{ cursor: 'pointer' }}
            onClick={() => history.push(`${location.pathname}/edit/${vendor.id}`)}
          />
        </Tooltip>
        <Tooltip title="Delete">
          <DeleteIcon
            color="action"
            style={{ marginLeft: 5, cursor: 'pointer' }}
            onClick={async () => {
              try {
                await confirm({
                  title: 'Delete exhibitor',
                  description: 'Are you sure you want to delete this exhibitor ?'
                })
                dispatch(deleteVendorById(user?.conferenceId, vendor.id))
              } catch {
                // do nothing
              }
            }}
          />
        </Tooltip>
      </>
    ])

  const options = getTableOptions()

  return (
    <>
      <ViewHeader title="Exhibitors">
        {inProgress && <Loading />}
        <ActionBar
          actionText="New Exhibitor"
          onAction={() => history.push(`${location.pathname}/new`)}
          searchPlaceholder="Search Exhibitor"
        />
      </ViewHeader>

      {vendors && vendors.length ? (
        <Paper variant="outlined" style={{ marginTop: 20 }}>
          <BasicTable
            data={formatTableData(vendors)}
            columns={tableHead}
            options={{
              ...options,
              onChangePage: (page) => dispatch(vendorSlice.actions.setCurrentPage(page)),
              onChangeRowsPerPage: (size) => dispatch(vendorSlice.actions.setPageSize(size)),
              page: currentPage,
              rowsPerPage: pageSize
            }}
          />
        </Paper>
      ) : (
        !inProgress && <ResourceNotFound message="No exhibitor available" />
      )}
    </>
  )
}

export default VendorListing
